import { captureFrameFromVideo } from '~/utils/file.js';
import { getFileNameWithoutExtension } from '~/utils/video-editor/clip-utils.js';

export function useCaptureVideoFrame({ file, fileContext }) {
  const frameSrc = ref('');
  const capturedFile = ref(null);
  const filesStore = useFilesStore();

  async function captureVideoFrame(videoElement) {
    const currentFile = unref(file);
    const ctx = unref(fileContext);

    capturedFile.value = null;
    frameSrc.value = captureFrameFromVideo({ videoElement });

    const newFile = await useUploadApi().uploadImage(frameSrc.value, {
      fileName: `${getFileNameWithoutExtension(currentFile)}_frame.jpg`,
      takenAt: currentFile.taken_at
    });

    if (ctx.contextId) {
      await filesStore.addFilesToContext({
        ids: [newFile.id],
        contextId: ctx.contextId,
        contextType: ctx.contextType
      });
    }

    const newFileDetails = await filesStore.getFileDetails({
      files: [newFile],
      contextId: ctx.contextId,
      contextType: ctx.contextType
    });

    await filesStore.insertFile({
      file: newFileDetails[0],
      afterFile: currentFile
    });

    capturedFile.value = newFileDetails[0];
  }

  return { frameSrc, capturedFile, captureVideoFrame };
}
